<template>
    <div class="construction-content">
        <div class="row border-radius bg-white padding-flex mb-1">
            <slot name="title" />

            <div :class="$root.is_mobile ? 'text-left' : 'text-right'">
                <a
                    :href="estate.pdf"
                    target="_blank"
                    rel="nofollow"
                    class="print-pdf"
                >
                    <!-- <img
                        v-if="$root.is_mobile"
                        src="/img/icons/pdf-file-red.svg"
                        :alt="trans('labels.print') | capitalize"
                    > -->
                    {{ trans('labels.print') }}
                </a>

                <a
                    v-if="estate.specifications"
                    :href="estate.specifications"
                    target="_blank"
                    class="print-pdf"
                >
                    <!-- <img
                        v-if="$root.is_mobile"
                        src="/img/icons/pdf-file-red.svg"
                        :alt="trans('labels.print') | capitalize"
                    > -->
                    {{ trans('labels.specifications') }}
                </a>
            </div>

            <div class="estate-description">
                <slot name="description" />
            </div>

            <construction-solutions
                v-if="estate.solutions"
                :estate="estate"
                :solutions="estate.solutions"
            />
        </div>
    </div>
</template>

<script>
import ConstructionSolutions from '../../components/constructions/Solutions'

export default {
    components: {
        'construction-solutions': ConstructionSolutions,
    },

    props: {
        estate: {
            type: Object,
            required: true,
        },
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },
}
</script>